import { render, staticRenderFns } from "./GameGuide.vue?vue&type=template&id=203cadf9&scoped=true&"
import script from "./GameGuide.vue?vue&type=script&lang=js&"
export * from "./GameGuide.vue?vue&type=script&lang=js&"
import style0 from "./GameGuide.vue?vue&type=style&index=0&id=203cadf9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "203cadf9",
  null
  
)

export default component.exports